import alt from '../components/alt';

class AppConfigActions {
  setConfig(config) {
    return config;
  }
}

export default alt.createActions(AppConfigActions);
